import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getPartnerCommission=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_PARTNER_COMMISSIONS_START
    })
    const options={
        url:`${api}/partnerCommissions`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_PARTNER_COMMISSIONS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_PARTNER_COMMISSIONS_FAIL,
                payload:getMessage(error)
            }))
}